/*استخر*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="swimming-pool (1)"
      xmlns="http://www.w3.org/2000/svg"
      width={95.982}
      height={95.982}
      viewBox="0 0 95.982 95.982"
      {...props}
    >
      <path
        data-name="Path 7874"
        d="M1.406 47.71h93.17v28.12H1.406z"
        fill="#2accf4"
      />
      <path
        data-name="Path 7875"
        d="M88.952 47.71h5.624v28.12h-5.624z"
        fill="#22b3eb"
      />
      <path
        data-name="Path 7876"
        d="M1.406 42.086h93.17v5.624H1.406z"
        fill="#8aeeff"
      />
      <path
        data-name="Path 7877"
        d="M88.952 42.086h5.624v5.624h-5.624z"
        fill="#63e5ff"
      />
      <path
        data-name="Path 7878"
        d="M22.308 74.986h-5.624V26.62a2.812 2.812 0 115.624 0z"
        fill="#f1f1f1"
      />
      <path
        data-name="Path 7879"
        d="M44.054 74.986H38.43V26.62a2.812 2.812 0 115.624 0z"
        fill="#f1f1f1"
      />
      <path
        data-name="Path 7880"
        d="M94.576 64.769c-3.883 0-3.883 3.251-7.765 3.251s-3.883-3.251-7.765-3.251-3.882 3.251-7.764 3.251-3.883-3.251-7.766-3.251-3.882 3.251-7.764 3.251-3.882-3.251-7.764-3.251-3.881 3.251-7.763 3.251-3.882-3.251-7.764-3.251-3.882 3.251-7.764 3.251-3.882-3.251-7.764-3.251-3.882 3.251-7.764 3.251-3.881-3.251-7.763-3.251v19.309a10.5 10.5 0 0010.5 10.5h72.172a10.5 10.5 0 0010.5-10.5z"
        fill="#b9f5ff"
      />
      <g data-name="Group 382" fill="#8aeeff">
        <path
          data-name="Path 7881"
          d="M50.128 68.02a4.86 4.86 0 002.812-.8c-1.476-.963-2.327-2.449-4.952-2.449a4.86 4.86 0 00-2.812.8c1.476.963 2.327 2.449 4.952 2.449z"
        />
        <path
          data-name="Path 7882"
          d="M65.656 68.02a4.862 4.862 0 002.812-.8c-1.476-.963-2.327-2.449-4.952-2.449a4.861 4.861 0 00-2.812.8c1.481.963 2.327 2.449 4.952 2.449z"
        />
        <path
          data-name="Path 7883"
          d="M34.601 68.02a4.86 4.86 0 002.812-.8c-1.476-.963-2.327-2.449-4.952-2.449a4.86 4.86 0 00-2.812.8c1.476.963 2.327 2.449 4.952 2.449z"
        />
        <path
          data-name="Path 7884"
          d="M81.186 68.02a4.862 4.862 0 002.812-.8c-1.477-.963-2.327-2.449-4.953-2.449a4.861 4.861 0 00-2.812.8c1.476.963 2.327 2.449 4.953 2.449z"
        />
        <path
          data-name="Path 7885"
          d="M88.954 67.589v16.489a10.5 10.5 0 01-10.5 10.5h5.624a10.5 10.5 0 0010.5-10.5V64.769c-2.999 0-3.684 1.936-5.624 2.82z"
        />
        <path
          data-name="Path 7886"
          d="M3.546 68.02a4.86 4.86 0 002.812-.8c-1.476-.963-2.326-2.449-4.951-2.449v2.82a5.033 5.033 0 002.139.429z"
        />
        <path
          data-name="Path 7887"
          d="M19.073 68.02a4.86 4.86 0 002.812-.8c-1.476-.963-2.327-2.449-4.952-2.449a4.861 4.861 0 00-2.812.8c1.473.963 2.327 2.449 4.952 2.449z"
        />
      </g>
      <g data-name="Group 383" fill="#d0d0d0">
        <path data-name="Path 7888" d="M22.308 28.963H38.43v5.624H22.308z" />
        <path data-name="Path 7889" d="M22.308 42.085H38.43v5.624H22.308z" />
        <path data-name="Path 7890" d="M22.308 55.208H38.43v5.624H22.308z" />
      </g>
      <circle
        data-name="Ellipse 392"
        cx={8.998}
        cy={8.998}
        r={8.998}
        transform="translate(65.612 8.061)"
        fill="#ffd54f"
      />
      <path
        data-name="Path 7891"
        d="M74.611 8.061a8.981 8.981 0 00-2.812.451 9 9 0 010 17.1 9 9 0 102.812-17.551z"
        fill="#ffc128"
      />
      <g data-name="Group 384">
        <path
          data-name="Path 7892"
          d="M94.576 40.68H90.17a1.406 1.406 0 100 2.812h3v2.81H45.46v-2.81h38.149a1.406 1.406 0 000-2.812H45.46V26.62a4.222 4.222 0 00-4.218-4.218 4.223 4.223 0 00-4.218 4.218v.937h-13.31v-.937a4.222 4.222 0 00-4.214-4.218 4.223 4.223 0 00-4.218 4.218v3.369a1.406 1.406 0 002.812 0V26.62a1.407 1.407 0 011.406-1.406 1.41 1.41 0 011.406 1.406v38.043a6.236 6.236 0 00-2.812-1.21V35.911a1.406 1.406 0 10-2.812 0v4.768H1.406A1.406 1.406 0 000 42.086v41.992a11.917 11.917 0 0011.9 11.9h72.178a11.917 11.917 0 0011.9-11.9V42.086a1.406 1.406 0 00-1.402-1.406zm-54.74-14.06a1.408 1.408 0 011.406-1.406 1.41 1.41 0 011.406 1.406v39.149a3.568 3.568 0 01-2.423.845c-.137 0-.265-.007-.389-.016zm-2.812 19.682h-13.31v-2.81h13.31zm0 2.812v4.688h-13.31v-4.687zm-13.31 7.5h13.31v2.812h-13.31zm13.31-15.934h-13.31v-4.687h13.31zm-13.31 21.558h13.31v2.894a6.575 6.575 0 00-4.563-1.769 6.774 6.774 0 00-4.785 1.953 4.063 4.063 0 01-2.979 1.3 4.163 4.163 0 01-.983-.107zm13.31-31.869v2.812h-13.31v-2.812zM2.812 49.116h12.466v14.435a7.384 7.384 0 00-3.13 1.766 4.069 4.069 0 01-5.958 0 7.213 7.213 0 00-3.378-1.815V49.116zm0-5.624h12.466v2.81H2.812zM93.17 84.078a9.1 9.1 0 01-9.092 9.092H11.9a9.1 9.1 0 01-9.092-9.092V66.414a5.757 5.757 0 011.573 1.058 6.836 6.836 0 009.569 0 4.069 4.069 0 015.959 0 9.957 9.957 0 001.7 1.216l.068.036a6.33 6.33 0 003.018.7 6.773 6.773 0 004.785-1.953 4.07 4.07 0 015.959 0 8.05 8.05 0 002.524 1.584l.066.022a6.656 6.656 0 002.194.347 6.771 6.771 0 004.784-1.954 4.069 4.069 0 015.958 0 6.772 6.772 0 004.785 1.953 7.448 7.448 0 001.1-.078 1.406 1.406 0 10-.416-2.781 4.624 4.624 0 01-.68.047 4.063 4.063 0 01-2.979-1.3 6.772 6.772 0 00-4.785-1.953 6.5 6.5 0 00-2.528.473V49.116H93.17v14.386a7.215 7.215 0 00-3.379 1.818 4.071 4.071 0 01-5.96 0 6.837 6.837 0 00-9.57 0 4.07 4.07 0 01-5.959 0 6.772 6.772 0 00-4.785-1.953 6.7 6.7 0 00-2.1.314 1.406 1.406 0 00.87 2.674 3.939 3.939 0 011.231-.176 4.063 4.063 0 012.98 1.3 6.837 6.837 0 009.57 0 4.07 4.07 0 015.959 0 6.838 6.838 0 009.57 0 5.751 5.751 0 011.574-1.058v17.664z"
        />
        <path
          data-name="Path 7893"
          d="M74.606 6.655a10.4 10.4 0 1010.4 10.4 10.416 10.416 0 00-10.4-10.4zm0 18a7.592 7.592 0 117.6-7.6 7.6 7.6 0 01-7.6 7.6z"
        />
        <path
          data-name="Path 7894"
          d="M74.611 5.436a1.406 1.406 0 001.406-1.406V1.406a1.406 1.406 0 10-2.812 0V4.03a1.406 1.406 0 001.406 1.406z"
        />
        <path
          data-name="Path 7895"
          d="M73.299 29.901v2.624a1.406 1.406 0 002.812 0v-2.624a1.406 1.406 0 00-2.812 0z"
        />
        <path
          data-name="Path 7896"
          d="M66.926 6.465a1.406 1.406 0 002.435-1.406l-1.312-2.273a1.406 1.406 0 00-2.435 1.406z"
        />
        <path
          data-name="Path 7897"
          d="M80.456 26.903a1.406 1.406 0 00-.515 1.921l1.312 2.273a1.406 1.406 0 002.435-1.406l-1.312-2.273a1.406 1.406 0 00-1.92-.515z"
        />
        <path
          data-name="Path 7898"
          d="M60.433 10.403l2.273 1.312a1.406 1.406 0 001.405-2.434l-2.273-1.312a1.406 1.406 0 10-1.406 2.435z"
        />
        <path
          data-name="Path 7899"
          d="M85.157 24.569l2.273 1.311a1.406 1.406 0 101.406-2.435l-2.273-1.312a1.406 1.406 0 00-1.406 2.435z"
        />
        <path
          data-name="Path 7900"
          d="M59.051 18.372h2.625a1.406 1.406 0 100-2.812h-2.625a1.406 1.406 0 000 2.812z"
        />
        <path
          data-name="Path 7901"
          d="M86.14 16.872a1.406 1.406 0 001.406 1.406h2.625a1.406 1.406 0 000-2.812h-2.625a1.406 1.406 0 00-1.406 1.406z"
        />
        <path
          data-name="Path 7902"
          d="M62.706 22.216l-2.273 1.312a1.406 1.406 0 101.406 2.435l2.272-1.312a1.406 1.406 0 10-1.406-2.435z"
        />
        <path
          data-name="Path 7903"
          d="M85.768 11.823a1.4 1.4 0 00.7-.189l2.273-1.312a1.406 1.406 0 10-1.406-2.435l-2.273 1.312a1.406 1.406 0 00.7 2.624z"
        />
        <path
          data-name="Path 7904"
          d="M66.926 27.464l-1.312 2.273a1.406 1.406 0 102.435 1.406l1.312-2.273a1.406 1.406 0 10-2.435-1.406z"
        />
        <path
          data-name="Path 7905"
          d="M80.294 6.934a1.405 1.405 0 001.921-.515l1.312-2.273a1.406 1.406 0 10-2.435-1.406L79.78 5.013a1.406 1.406 0 00.514 1.921z"
        />
        <path
          data-name="Path 7906"
          d="M22.496 74.33h-5.624a1.406 1.406 0 100 2.812h5.624a1.406 1.406 0 100-2.812z"
        />
        <path
          data-name="Path 7907"
          d="M79.105 82.578h-7.5a1.406 1.406 0 100 2.812h7.5a1.406 1.406 0 100-2.812z"
        />
        <path
          data-name="Path 7908"
          d="M62.988 77.142H47.241a1.406 1.406 0 000 2.812h15.747a1.406 1.406 0 000-2.812z"
        />
        <path
          data-name="Path 7909"
          d="M37.489 81.266h-10.5a1.406 1.406 0 100 2.812h10.5a1.406 1.406 0 100-2.812z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
